module.exports = {
    domain: {
        InApi: 'https://wt.maswater.cn/InApi_MAS/', //模块一接口地址
        OutApi:'https://dwt.micrstone.com:8889/OutApi_DZQ_MAS/', //模块二接口地址
        TestApi: 'https://wt.maswater.cn/InApi_MAS_Test/', //模块三接口地址
        Base_M4_URL: '', //模块四接口地址
    }
};